import {
  AnalyticsField,
  FilterComparison,
  FilterLogic,
  PivotTableLayout,
  Widget,
} from '@types'

import { LINKED_TRANSACTION_FIELD } from '@/const'
import { DEFAULT_COLS } from '@/views/Dashboards/Dashboard/Widgets/LinkedTransactions/utils/const'
import { DEFAULT_CONFIG_NAME } from '@/components/UI/PivotTable/utils/const'

import { generateRandomKey } from '@/helpers/common'

export const getDefaultLinkedTransactionsAttrs = (): Widget['attrs'] => ({
  count: 15,
  filter: {
    params: [
      {
        key: generateRandomKey(),
        params: [
          {
            key: generateRandomKey(),
            comparison: FilterComparison.NOTCONTAINS,
            field: LINKED_TRANSACTION_FIELD.TAGS,
            value: 'exclude',
          },
        ],
        logic: FilterLogic.AND,
      },
    ],
    logic: FilterLogic.AND,
  },
  cols: DEFAULT_COLS,
})

export const getDefaultValuePivotAttrs = (): Widget['attrs'] => ({
  index: 0,
  configs: [
    {
      name: DEFAULT_CONFIG_NAME,
      open: true,
      layout: PivotTableLayout.MODERN,
      filter: {
        params: [
          {
            params: [
              {
                key: generateRandomKey(),
                comparison: FilterComparison.NOTEQ,
                field: AnalyticsField.POSITION_CLOSE,
                value: '0',
              },
            ],
            logic: FilterLogic.AND,
            key: generateRandomKey(),
          },
        ],
        logic: FilterLogic.AND,
      },
      sortColumns: [],
      sortRows: [],
    },
  ],
})

export const getDefaultCashFlowProjectionsAttrs = (): Widget['attrs'] => ({
  columns: ['account_name', 'asset_name', 'value'],
  projectionBy: 'month',
})

export const getDefaultTreePivotAttrs = (): Widget['attrs'] => ({
  index: 0,
  configs: [
    {
      name: DEFAULT_CONFIG_NAME,
      open: true,
      layout: PivotTableLayout.MODERN,
      // No `fields` here on purpose, same as getDefaultValuePivotAttrs: the widget's own
      // pivotFields owns the default layout, so it stays a single source of truth.
      sortColumns: [],
      sortRows: [],
    },
  ],
})
